import { APP_PATHS } from '../../../domain/apps'

export const prepareEnvData = () => ({
  isCiq: window.location.href.includes('authenticated'),
  isEphemeral: window.location.hostname.endsWith('ephemeral.caisgroup.com'),
  isLocalhost: window.location.href.includes('localhost'),
  isMfe: APP_PATHS.some((mfeApp) => window.location.href.includes(mfeApp)),
})
